const postsNorwegian = {
  header: {
    title: "Mine LinkedIn Innlegg",
    postsLeft: "{remaining}/{limit} innlegg igjen denne uken"
  },
  limitWarning: {
    used: "Du har brukt opp dine {limit} ukentlige innlegg. Oppgrader abonnementet ditt for å få flere.",
    upgrade: "Oppgrader abonnement",
    low: "Du har {remaining} innlegg igjen denne uken. Planlegg dem nøye."
  },
  loading: "Laster innlegg...",
  noPostsMessage: {
    title: "Ingen planlagte innlegg",
    help: "Bruk Telegram-boten for å planlegge nye innlegg"
  },
  postCard: {
    date: "{date}",
    time: "{time}",
    status: {
      scheduled: "Planlagt",
      published: "Publisert"
    },
    image: "Bilde vedlagt",
    actions: {
      share: "Del på LinkedIn",
      sharing: "Deler...",
      delete: "Slett",
      deleting: "Sletter..."
    }
  },
  confirmation: {
    delete: "Er du sikker på at du vil slette dette innlegget?"
  },
  result: {
    success: "Innlegg delt på LinkedIn!",
    errorPrefix: "Feil: ",
    postDeleted: "Innlegg slettet!"
  },
  customerBanner: "Du ser innlegg for {customerName}",
  calendar: {
    viewToggle: {
      month: "Måned",
      week: "Uke"
    },
    weekDays: {
      sunday: "Søndag",
      monday: "Mandag",
      tuesday: "Tirsdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lørdag"
    },
    weekHeader: "Uke {week} - {month} {year}",
    noTime: "Ingen tid"
  },
  modal: {
    title: "Innleggsdetaljer",
    sections: {
      content: "Innhold",
      schedule: "Planlagt tidspunkt",
      status: "Status",
      image: "Bilde"
    },
    schedule: {
      noTime: "Ingen tid planlagt",
      edit: "Endre",
      date: "Dato",
      time: "Tid",
      cancel: "Avbryt",
      save: "Lagre"
    },
    status: {
      published: "Publisert",
      ready: "Klar for publisering",
      scheduled: "Planlagt",
      unknown: "Ukjent"
    },
    actions: {
      delete: "Slett innlegg",
      share: "Del på LinkedIn"
    }
  }
};

export default postsNorwegian; 